/**
 * Badge tones, from the design system's semantic palette.
 *
 * Separate from the component so that file exports only a component (fast
 * refresh). Foreground and background always travel together — a foreground
 * over the wrong tint is the usual way contrast quietly fails.
 */
export const BADGE_TONES = {
  ok: 'text-sem-ok bg-sem-ok-bg',
  info: 'text-sem-info bg-sem-info-bg',
  plan: 'text-sem-plan bg-sem-plan-bg',
  mute: 'text-sem-mute bg-sem-mute-bg',
  warn: 'text-sem-warn bg-sem-warn-bg',
  bad: 'text-sem-bad bg-sem-bad-bg',
} as const;

export type BadgeTone = keyof typeof BADGE_TONES;
